export const ROUTER = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  AGURI: '/aguri',
  ALIO: '/alio',
  FASHION: '/verite',
  CAKE: '/cake',
  DESIGNS: '/designs',
  ABOUTTEST: '/abouttest',
  BEAUTYBLOG: '/beautyblog',
  NOTFOUND : '/404',
  PROJECT_DETAIL: '/designs/:id',
  WORKOUT : '/workout',
  ARCHITEC: '/architec',
  SCHEDULE: '/schedule',
  TEST: '/test',
  SHORT: '/short',
  SHOPIFYAPP: '/shopifyapp',
}